import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';

const Privacy = () => {
  const { t, isRTL } = useLanguage();

  return (
    <div className={`min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 ${isRTL ? 'font-arabic' : 'font-english'}`}>
      <div className="pt-24 pb-16 px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className='max-w-4xl mx-auto'
        >
          <h1 className={`text-4xl font-bold text-gray-900 mb-8 ${isRTL ? 'text-right' : 'text-left'}`}>
            {t('privacyPolicy')}
          </h1>

          <div className='bg-white rounded-xl shadow-lg p-8 space-y-8'>
            <section>
              <h2 className={`text-2xl font-semibold text-gray-800 mb-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                Information We Collect
              </h2>
              <p className={`text-gray-600 leading-relaxed mb-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                We collect information that you provide directly to us when using our verification
                service, including:
              </p>
              <ul className={`list-disc list-inside text-gray-600 leading-relaxed ${isRTL ? 'text-right' : 'text-left'}`}>
                <li>Product verification codes</li>
                <li>Search queries</li>
                <li>Device information</li>
                <li>Usage data</li>
              </ul>
            </section>

            <section>
              <h2 className={`text-2xl font-semibold text-gray-800 mb-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                How We Use Your Information
              </h2>
              <p className={`text-gray-600 leading-relaxed ${isRTL ? 'text-right' : 'text-left'}`}>We use the collected information to:</p>
              <ul className={`list-disc list-inside text-gray-600 leading-relaxed ${isRTL ? 'text-right' : 'text-left'}`}>
                <li>Verify product authenticity</li>
                <li>Improve our services</li>
                <li>Analyze usage patterns</li>
                <li>Prevent fraud</li>
                <li>Comply with legal obligations</li>
              </ul>
            </section>

            <section>
              <h2 className={`text-2xl font-semibold text-gray-800 mb-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                Data Security
              </h2>
              <p className={`text-gray-600 leading-relaxed ${isRTL ? 'text-right' : 'text-left'}`}>
                We implement appropriate security measures to protect your information from unauthorized
                access, alteration, disclosure, or destruction. However, no method of transmission over
                the Internet is 100% secure, and we cannot guarantee absolute security.
              </p>
            </section>

            <section>
              <h2 className={`text-2xl font-semibold text-gray-800 mb-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                Contact Us
              </h2>
              <p className={`text-gray-600 leading-relaxed ${isRTL ? 'text-right' : 'text-left'}`}>
                If you have any questions about our Privacy Policy, please contact us at:
              </p>
              <ul className={`list-none text-gray-600 leading-relaxed mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                <li>Email: privacy@kuwait-chemicals.com</li>
                <li>Phone: +965 2XXX XXXX</li>
                <li>Address: Kuwait City, Kuwait</li>
              </ul>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Privacy;
